// 商品
const GOODS = {
  goodsListByCate: {
    apiUrl: '/goods/queryGoodsListByCategoryId',
    method: 'POST'
  }, // 商品列表
  goodsListById: {
    apiUrl: '/goods/getGoodsListByCategoryId',
    method: 'POST'
  }, // 设计师系列
  goodsDetail: { apiUrl: '/goods/queryGoodsListByCode', method: 'POST' }, // 商品详情
  recommendByCategoryId: {
    apiUrl: '/category/queryRecommendByCategoryId',
    method: 'POST'
  }, // 推荐商品
  searchGoodsList: {
    // 搜索商品
    apiUrl: '/goods/queryGoodsName',
    method: 'POST'
  },
  banner: {
    // 各个模块banner
    apiUrl: '/base/querybannersbymodel',
    method: 'get',
    set: { query: true }
  }
}
export default GOODS
